<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M7.99984 8.66634C9.10441 8.66634 9.99984 7.77091 9.99984 6.66634C9.99984 5.56177 9.10441 4.66634 7.99984 4.66634C6.89527 4.66634 5.99984 5.56177 5.99984 6.66634C5.99984 7.77091 6.89527 8.66634 7.99984 8.66634Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99984 14.6663C10.6665 11.9997 13.3332 9.61186 13.3332 6.66634C13.3332 3.72082 10.9454 1.33301 7.99984 1.33301C5.05432 1.33301 2.6665 3.72082 2.6665 6.66634C2.6665 9.61186 5.33317 11.9997 7.99984 14.6663Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
